module.exports = __webpack_public_path__ + "static/media/two-bed-spacious-bg-1.c12e57a0.jpg";